const initialState = {
    language: "eng",
};

export const languageReducer = (state = initialState, action) => {
    switch(action.type) {
        case "LANGUAGE_SET":
            return {
                ...state,
                language: action.payload,
            };
        default:
            return state;
    }
};
